export const messages = {
  en: {
    carStructure: {
      noOwner: 'No Owner',
      oweAmount: 'Arrears',
      yuan: 'Yuan',
      searchPlaceholder: 'Please enter house number building-unit-room such as 1-1-1',
      fetchError: 'Failed to fetch car structure data'
    },
    floorUnitTree: {
      noBuilding: 'No building currently',
      building: 'Building',
      unit: 'Unit',
      fetchError: 'Failed to fetch floor and unit data'
    }
  },
  zh: {
    carStructure: {
      noOwner: '无',
      oweAmount: '欠费',
      yuan: '元',
      searchPlaceholder: '请输入房屋编号 楼栋-单元-房屋 如1-1-1',
      fetchError: '获取车位结构数据失败'
    },
    floorUnitTree: {
      noBuilding: '当前没有楼栋',
      building: '栋',
      unit: '单元',
fetchError: '获取楼栋单元数据失败'
    }
  },
  'zh-TW': {
    carStructure: {
      noOwner: '無',
      oweAmount: '欠費',
      yuan: '元',
      searchPlaceholder: '請輸入房屋編號 樓棟-單元-房屋 如1-1-1',
      fetchError: '獲取車位結構數據失敗'
    },
    floorUnitTree: {
      noBuilding: '當前沒有樓棟',
      building: '棟',
      unit: '單元',
      fetchError: '獲取樓棟單元數據失敗'
    }
  }
}